import Joi from 'joi';

/**
 * Schema for existing record validation.
 */
export const updateVehicleMakeSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
